import { render, staticRenderFns } from "./InspectionFooter.vue?vue&type=template&id=96258a6c&scoped=true&"
import script from "./InspectionFooter.vue?vue&type=script&lang=js&"
export * from "./InspectionFooter.vue?vue&type=script&lang=js&"
import style0 from "./InspectionFooter.vue?vue&type=style&index=0&id=96258a6c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96258a6c",
  null
  
)

export default component.exports